module.exports = __webpack_public_path__ + "493386a5649baa1358b28ddaac7fef9b.svg";